export type Qty = Record<string, number>;

export function qtyLine(q: Qty | undefined | null): string {
  const keys = Object.keys(q || {});
  if (!keys.length) return '—';
  return keys.map((k) => `${k}: ${(q as Qty)[k]}`).join(' · ');
}

/** Total toutes caisses confondues (ex : {PM:12, GM:8} -> 20). */
export function sumQty(q: Qty | undefined | null): number {
  return Object.values(q || {}).reduce((a, b) => a + b, 0);
}

/** Paires [type de caisse, quantité], dans l'ordre où le backend les renvoie. */
export function qtyEntries(q: Qty | undefined | null): [string, number][] {
  return Object.entries(q || {});
}

export function esc(s: unknown): string {
  return String(s === undefined || s === null ? '' : s);
}
